import {cs}            from "./chain-services";
import {fragments}     from "./fragments";
import {Invoke}        from "./invoke";
import {OnUnmounted}   from "./on-unmounted";
import {TimeoutAction} from "./timeout-action";
import {UseState}      from "./use-state";

export const DebounceCache = ({state, onActive=undefined, onInactive=undefined, delay=500, next}) => cs(
    ["cache", (_, next) => UseState({next})],
    ({cache}) => fragments(
        cache.value && TimeoutAction({
            delay,
            action: () => {
                state.onChange(cache.value.value);
                cache.onChange(null);
            },
        }),

        onActive && cache.value && Invoke({
            action: onActive,
        }),
        onInactive && cache.value && OnUnmounted({
            action: onInactive,
        }),

        next({
            state: {
                value: !cache.value ? state.value : cache.value.value,
                onChange: (value) => cache.onChange({
                    time: Date.now(),
                    value,
                }),
            },
            active: !!cache.value,
            flush: () => {
                if (cache.value) {
                    state.onChange(cache.value.value);
                    cache.onChange(null);
                }
            },
        }),
    ),
);